function instantBuy(fromid){
     var $ = jQuery;

   var formParams = $('#'+fromid).serialize();
  console.log("============uyyyyyyy=============")
  console.log(formParams)

     $.ajax({
      url: "/cart/add",
      type: "post",
      data: formParams,
      success: function(){ 

             //   console.log("============uyyyyyyy=============")
       window.location.href = "/checkout";


      },
      error: function(){
      }
     })
 }